import * as PropTypes from 'prop-types'

const JobsPoolsShape = PropTypes.shape({

})

export { JobsPoolsShape }
